import { httpError } from '#app/api/errors'

export type SessionInfo = {
    authenticated: boolean
    firstName: string | null
    lastName: string | null
}

export async function fetchSession(): Promise<SessionInfo> {
    const response = await fetch('/api/session', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    })
    if (!response.ok) {
        throw await httpError(response, 'GET /api/session')
    }
    const body = await response.json()
    return {
        authenticated: body.authenticated === true,
        firstName: body.firstName ?? null,
        lastName: body.lastName ?? null,
    }
}

export async function logout(): Promise<void> {
    await fetch('/api/session/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: 'true',
    })
}

export function displayName(session: SessionInfo): string {
    const parts = [session.firstName, session.lastName].filter(Boolean)
    return parts.length > 0 ? parts.join(' ') : 'Signed-in user'
}
